import React from 'react';

const WatchmakerCharacter = ({ width = 220, height = 310, style = {} }) => (
  <svg
    viewBox="0 0 220 320"
    width={width}
    height={height}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="wm_skin" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#f8d8b0" />
        <stop offset="100%" stopColor="#d4a070" />
      </radialGradient>
      <radialGradient id="wm_head" cx="38%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#f8d8b0" />
        <stop offset="60%" stopColor="#e8b888" />
        <stop offset="100%" stopColor="#c89060" />
      </radialGradient>
      <linearGradient id="wm_shirt" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f8f4ee" />
        <stop offset="100%" stopColor="#e0d8ce" />
      </linearGradient>
      <linearGradient id="wm_vest" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#2c3050" />
        <stop offset="55%" stopColor="#1c2038" />
        <stop offset="100%" stopColor="#121628" />
      </linearGradient>
      <linearGradient id="wm_pants" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#282c40" />
        <stop offset="100%" stopColor="#141820" />
      </linearGradient>
      <linearGradient id="wm_shoe" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#1c1c1c" />
        <stop offset="100%" stopColor="#080808" />
      </linearGradient>
      <radialGradient id="wm_watch_case" cx="35%" cy="28%" r="65%">
        <stop offset="0%" stopColor="#ffe060" />
        <stop offset="55%" stopColor="#d4a820" />
        <stop offset="100%" stopColor="#9a7010" />
      </radialGradient>
      <radialGradient id="wm_watch_face" cx="35%" cy="32%" r="60%">
        <stop offset="0%" stopColor="#fffcf2" />
        <stop offset="80%" stopColor="#f0e8d4" />
        <stop offset="100%" stopColor="#e0d4b8" />
      </radialGradient>
      <linearGradient id="wm_hair" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#f0eee8" />
        <stop offset="60%" stopColor="#d8d0c4" />
        <stop offset="100%" stopColor="#beb2a8" />
      </linearGradient>
      <linearGradient id="wm_loupe" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e0c040" />
        <stop offset="100%" stopColor="#9a7820" />
      </linearGradient>
      <linearGradient id="wm_bow_tie" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#d81020" />
        <stop offset="100%" stopColor="#7a0810" />
      </linearGradient>
      <linearGradient id="wm_chain" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#d4a820" />
        <stop offset="50%" stopColor="#f8d848" />
        <stop offset="100%" stopColor="#d4a820" />
      </linearGradient>
      <linearGradient id="wm_apron" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#d8cca8" />
        <stop offset="100%" stopColor="#b8aa88" />
      </linearGradient>
      <filter id="wm_drop" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.35" />
      </filter>
      <filter id="wm_glow" x="-40%" y="-40%" width="180%" height="180%">
        <feDropShadow dx="0" dy="0" stdDeviation="5" floodColor="#d4a820" floodOpacity="0.65" />
      </filter>
    </defs>

    {/* Ground shadow */}
    <ellipse cx="110" cy="317" rx="78" ry="7" fill="rgba(0,0,0,0.4)" />

    {/* ══ SHOES ══ */}
    <ellipse cx="86" cy="313" rx="23" ry="7" fill="url(#wm_shoe)" stroke="#080808" strokeWidth="1.5" />
    <ellipse cx="136" cy="313" rx="23" ry="7" fill="url(#wm_shoe)" stroke="#080808" strokeWidth="1.5" />
    <ellipse cx="90" cy="311" rx="9" ry="2.5" fill="rgba(255,255,255,0.13)" />
    <ellipse cx="140" cy="311" rx="9" ry="2.5" fill="rgba(255,255,255,0.13)" />

    {/* ══ LEGS (dark trousers) ══ */}
    <path d="M 78 268 Q 76 284 76 298 Q 77 310 88 312 Q 98 312 100 300 Q 100 284 96 268 Z"
      fill="url(#wm_pants)" stroke="#0e0e18" strokeWidth="1.5" />
    <path d="M 142 268 Q 144 284 144 298 Q 143 310 132 312 Q 122 312 120 300 Q 120 284 124 268 Z"
      fill="url(#wm_pants)" stroke="#0e0e18" strokeWidth="1.5" />
    <line x1="87" y1="270" x2="88" y2="308" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
    <line x1="133" y1="270" x2="132" y2="308" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />

    {/* ══ TORSO ══ */}
    {/* White shirt outer */}
    <path d="M 70 172 Q 62 218 60 268 L 160 268 Q 158 218 150 172 Z"
      fill="url(#wm_shirt)" stroke="#c0b8aa" strokeWidth="1.5" />
    {/* Dark navy vest */}
    <path d="M 79 172 Q 72 218 70 268 L 150 268 Q 148 218 141 172 Z"
      fill="url(#wm_vest)" stroke="#0c1020" strokeWidth="2" filter="url(#wm_drop)" />
    <path d="M 79 172 Q 73 218 71 268 L 110 268 L 110 172 Z" fill="rgba(0,0,0,0.12)" />
    {/* Vest V-lapels */}
    <path d="M 96 172 L 80 202 L 110 218 L 140 202 L 124 172 Z"
      fill="url(#wm_shirt)" stroke="#b8b0a4" strokeWidth="1" />
    <path d="M 104 172 L 92 205 L 110 214 Z" fill="url(#wm_shirt)" />
    <path d="M 116 172 L 128 205 L 110 214 Z" fill="url(#wm_shirt)" />
    <line x1="92" y1="205" x2="110" y2="214" stroke="rgba(180,170,155,0.5)" strokeWidth="0.8" />
    <line x1="128" y1="205" x2="110" y2="214" stroke="rgba(180,170,155,0.5)" strokeWidth="0.8" />

    {/* Gold buttons down vest */}
    {[0, 1, 2, 3, 4].map((i) => (
      <g key={i}>
        <circle cx="110" cy={218 + i * 10} r="2.8" fill="#c8a830" stroke="#9a7820" strokeWidth="0.8" />
        <circle cx="109" cy={217 + i * 10} r="1" fill="rgba(255,230,120,0.4)" />
      </g>
    ))}

    {/* Watch chain from vest pocket */}
    <path d="M 124 228 Q 128 236 126 246 Q 124 252 120 256"
      fill="none" stroke="url(#wm_chain)" strokeWidth="2" strokeDasharray="2.5,1.5" strokeLinecap="round" />
    <path d="M 115 226 Q 130 225 132 233 L 113 234 Z"
      fill="none" stroke="#c8a830" strokeWidth="1.2" />

    {/* ══ LINEN WORK APRON (lower half) ══ */}
    <path d="M 86 242 Q 86 268 88 268 L 132 268 Q 134 268 134 242 Q 122 238 110 238 Q 98 238 86 242 Z"
      fill="url(#wm_apron)" stroke="#a8a080" strokeWidth="1" opacity="0.9" />
    <line x1="86" y1="242" x2="76" y2="238" stroke="#c8b890" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="134" y1="242" x2="144" y2="238" stroke="#c8b890" strokeWidth="1.5" strokeLinecap="round" />
    {/* Apron pocket with tools */}
    <rect x="102" y="252" width="16" height="10" rx="1" fill="none" stroke="#a8a078" strokeWidth="1" />
    <line x1="106" y1="252" x2="106" y2="248" stroke="#c0a040" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="110" y1="252" x2="110" y2="247" stroke="#b8b8b8" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="114" y1="252" x2="114" y2="249" stroke="#c0a040" strokeWidth="1.5" strokeLinecap="round" />

    {/* ══ BOW TIE (deep red — Swiss colours) ══ */}
    <path d="M 93 185 L 105 193 L 110 186 L 115 193 L 127 185 L 116 180 L 110 182 L 104 180 Z"
      fill="url(#wm_bow_tie)" stroke="#600810" strokeWidth="0.8" />
    <ellipse cx="110" cy="187" rx="4" ry="3.5" fill="#900a14" />
    <ellipse cx="100" cy="186" rx="5" ry="2.5" fill="rgba(255,100,100,0.2)" transform="rotate(-10,100,186)" />
    <ellipse cx="120" cy="186" rx="5" ry="2.5" fill="rgba(200,20,30,0.15)" transform="rotate(10,120,186)" />

    {/* ══ LEFT ARM (holding tweezers + gear) ══ */}
    <path d="M 80 188 Q 56 210 40 232 Q 30 250 26 268"
      fill="none" stroke="#0c1020" strokeWidth="26" strokeLinecap="round" opacity="0.45" />
    <path d="M 80 188 Q 56 210 40 232 Q 30 250 26 268"
      fill="none" stroke="url(#wm_vest)" strokeWidth="22" strokeLinecap="round" />
    <ellipse cx="24" cy="270" rx="11" ry="8" fill="url(#wm_shirt)" stroke="#b0a898" strokeWidth="1.5"
      transform="rotate(12,24,270)" />
    <ellipse cx="22" cy="274" rx="9" ry="7" fill="url(#wm_skin)" stroke="#c09070" strokeWidth="1.5"
      transform="rotate(10,22,274)" />
    {/* Tweezers */}
    <line x1="19" y1="274" x2="12" y2="294" stroke="#c0c8d0" strokeWidth="3" strokeLinecap="round" />
    <line x1="26" y1="274" x2="19" y2="294" stroke="#c0c8d0" strokeWidth="2.5" strokeLinecap="round" />
    {/* Tiny gear held by tweezers */}
    {[0, 1, 2, 3, 4, 5, 6, 7].map(i => {
      const a = (i * 45) * Math.PI / 180;
      return <line key={i}
        x1={15 + 5.5 * Math.cos(a)} y1={297 + 5.5 * Math.sin(a)}
        x2={15 + 7.5 * Math.cos(a)} y2={297 + 7.5 * Math.sin(a)}
        stroke="#c8a820" strokeWidth="2" strokeLinecap="round" />;
    })}
    <circle cx="15" cy="297" r="5" fill="rgba(200,168,32,0.2)" />
    <circle cx="15" cy="297" r="3.5" fill="#d4a820" stroke="#9a7810" strokeWidth="1" />
    <circle cx="15" cy="297" r="1.5" fill="#b88a18" />

    {/* ══ RIGHT ARM (raised, presenting pocket watch) ══ */}
    <path d="M 140 188 Q 166 170 184 154 Q 196 142 200 132"
      fill="none" stroke="#0c1020" strokeWidth="26" strokeLinecap="round" opacity="0.45" />
    <path d="M 140 188 Q 166 170 184 154 Q 196 142 200 132"
      fill="none" stroke="url(#wm_vest)" strokeWidth="22" strokeLinecap="round" />
    <ellipse cx="202" cy="130" rx="11" ry="8" fill="url(#wm_shirt)" stroke="#b0a898" strokeWidth="1.5"
      transform="rotate(-28,202,130)" />
    <ellipse cx="205" cy="126" rx="9" ry="7" fill="url(#wm_skin)" stroke="#c09070" strokeWidth="1.5"
      transform="rotate(-30,205,126)" />

    {/* ══ POCKET WATCH ══ */}
    {/* Gold depth ring behind */}
    <circle cx="195" cy="105" r="27" fill="#b88808" stroke="#8a6608" strokeWidth="2" filter="url(#wm_glow)" />
    {/* Case front */}
    <circle cx="193" cy="103" r="27" fill="url(#wm_watch_case)" stroke="#9a7010" strokeWidth="2.5" />
    {/* Decorative engraved rings */}
    <circle cx="193" cy="103" r="24" fill="none" stroke="rgba(255,230,100,0.35)" strokeWidth="1.2" />
    <circle cx="193" cy="103" r="20" fill="none" stroke="rgba(255,220,80,0.2)" strokeWidth="0.8" />
    {/* Watch face (cream/ivory) */}
    <circle cx="193" cy="103" r="22" fill="url(#wm_watch_face)" stroke="#c8a030" strokeWidth="1.5" />
    <circle cx="193" cy="103" r="20" fill="none" stroke="rgba(140,95,25,0.22)" strokeWidth="0.8" />
    {/* Hour marks */}
    {[...Array(12)].map((_, i) => {
      const a = (i * 30 - 90) * Math.PI / 180;
      const r1 = i % 3 === 0 ? 13 : 15;
      return <line key={i}
        x1={193 + r1 * Math.cos(a)} y1={103 + r1 * Math.sin(a)}
        x2={193 + 19 * Math.cos(a)} y2={103 + 19 * Math.sin(a)}
        stroke="#3a2010" strokeWidth={i % 3 === 0 ? 2.5 : 1.5} />;
    })}
    {/* Roman numerals */}
    <text x="193" y="88" textAnchor="middle" fontSize="5" fill="#3a2010" fontFamily="serif" fontWeight="bold">XII</text>
    <text x="209" y="106" textAnchor="middle" fontSize="5" fill="#3a2010" fontFamily="serif" fontWeight="bold">III</text>
    <text x="193" y="122" textAnchor="middle" fontSize="5" fill="#3a2010" fontFamily="serif" fontWeight="bold">VI</text>
    <text x="177" y="106" textAnchor="middle" fontSize="5" fill="#3a2010" fontFamily="serif" fontWeight="bold">IX</text>
    {/* Hands (set to ~10:10 — traditional watch display) */}
    <line x1="193" y1="103" x2="186" y2="91" stroke="#1a0c08" strokeWidth="3.5" strokeLinecap="round" />
    <line x1="193" y1="103" x2="201" y2="85" stroke="#1a0c08" strokeWidth="2.5" strokeLinecap="round" />
    <line x1="193" y1="103" x2="193" y2="118" stroke="#cc2200" strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="193" cy="103" r="3" fill="#c8a820" stroke="#9a7810" strokeWidth="1" />
    {/* Crown winding stem */}
    <rect x="212" y="100" width="8" height="6" rx="2.5" fill="#c8a820" stroke="#9a7810" strokeWidth="1" />
    {/* Chain from crown */}
    <path d="M 212 103 Q 208 114 205 124"
      fill="none" stroke="url(#wm_chain)" strokeWidth="1.8" strokeDasharray="2.5,2" strokeLinecap="round" />
    {/* Open case lid (flipped back) */}
    <path d="M 168 98 Q 164 83 174 76 Q 184 70 193 78 Q 200 84 200 94"
      fill="rgba(200,160,20,0.1)" stroke="#d4a820" strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="200" cy="94" r="2" fill="#c8a820" />
    {/* Engraving hint on lid inner */}
    <path d="M 172 100 Q 176 93 183 90 Q 188 88 193 90"
      fill="none" stroke="rgba(255,220,80,0.28)" strokeWidth="1" strokeLinecap="round" />

    {/* ══ NECK ══ */}
    <rect x="97" y="154" width="26" height="24" rx="11" fill="url(#wm_skin)" stroke="#b08060" strokeWidth="2" />
    <line x1="110" y1="156" x2="110" y2="175" stroke="rgba(180,120,60,0.18)" strokeWidth="1.2" />
    <ellipse cx="110" cy="176" rx="18" ry="6" fill="rgba(0,0,0,0.12)" />

    {/* ══ HEAD ══ */}
    <ellipse cx="110" cy="106" rx="48" ry="52" fill="url(#wm_head)" stroke="#111" strokeWidth="2.5"
      filter="url(#wm_drop)" />
    <ellipse cx="94" cy="86" rx="22" ry="18" fill="rgba(255,255,255,0.12)" transform="rotate(-15,94,86)" />

    {/* ══ WHITE HAIR ══ */}
    {/* Crown (thinning on top) */}
    <path d="M 63 102 Q 66 60 110 54 Q 154 60 157 102 Q 148 68 110 64 Q 72 68 63 102 Z"
      fill="url(#wm_hair)" stroke="#a0a0a0" strokeWidth="1.5" />
    {/* Thinning/bald patch */}
    <ellipse cx="110" cy="70" rx="24" ry="12" fill="rgba(230,175,120,0.38)" />
    {/* Left side puff */}
    <path d="M 63 102 Q 50 126 48 155 Q 46 174 50 188 Q 58 172 56 150 Q 57 128 65 112 Z"
      fill="url(#wm_hair)" />
    {/* Right side puff */}
    <path d="M 157 102 Q 170 126 172 155 Q 174 174 170 188 Q 162 172 164 150 Q 163 128 155 112 Z"
      fill="url(#wm_hair)" />
    {/* Crown highlight */}
    <path d="M 88 62 Q 110 57 132 64" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="3.5" strokeLinecap="round" />
    {/* Side texture */}
    <path d="M 64 106 Q 58 128 56 154" fill="none" stroke="rgba(200,194,186,0.5)" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M 156 106 Q 162 128 164 154" fill="none" stroke="rgba(200,194,186,0.5)" strokeWidth="1.5" strokeLinecap="round" />
    {/* Wispy crown strands */}
    <path d="M 92 66 Q 96 62 102 64" fill="none" stroke="rgba(240,236,228,0.6)" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M 116 63 Q 122 60 128 63" fill="none" stroke="rgba(240,236,228,0.6)" strokeWidth="1.2" strokeLinecap="round" />

    {/* ══ EARS ══ */}
    <ellipse cx="62" cy="112" rx="9" ry="13" fill="url(#wm_skin)" stroke="#b08060" strokeWidth="1.8" />
    <path d="M 64 102 Q 59 112 64 122" fill="none" stroke="#b08060" strokeWidth="1.5" strokeLinecap="round" />
    <ellipse cx="158" cy="112" rx="9" ry="13" fill="url(#wm_skin)" stroke="#b08060" strokeWidth="1.8" />
    <path d="M 156 102 Q 161 112 156 122" fill="none" stroke="#b08060" strokeWidth="1.5" strokeLinecap="round" />

    {/* ══ WRINKLES ══ */}
    <path d="M 84 88 Q 110 84 136 88" fill="none" stroke="rgba(160,100,60,0.22)" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M 86 94 Q 110 90 134 94" fill="none" stroke="rgba(160,100,60,0.18)" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M 89 100 Q 110 97 131 100" fill="none" stroke="rgba(160,100,60,0.14)" strokeWidth="1" strokeLinecap="round" />
    <path d="M 81 128 Q 78 140 82 152" fill="none" stroke="rgba(160,100,60,0.22)" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M 139 128 Q 142 140 138 152" fill="none" stroke="rgba(160,100,60,0.22)" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M 75 122 Q 70 118 67 116" fill="none" stroke="rgba(160,100,60,0.2)" strokeWidth="1" strokeLinecap="round" />
    <path d="M 75 126 Q 71 124 69 123" fill="none" stroke="rgba(160,100,60,0.15)" strokeWidth="0.8" strokeLinecap="round" />

    {/* ══ EYEBROWS (bushy white/silver) ══ */}
    <path d="M 74 98 Q 87 91 102 97" fill="none" stroke="#d8d0c4" strokeWidth="5.5" strokeLinecap="round" />
    <path d="M 118 97 Q 133 91 146 98" fill="none" stroke="#d8d0c4" strokeWidth="5.5" strokeLinecap="round" />
    <path d="M 76 98 Q 85 94 97 97" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M 120 97 Q 129 94 144 98" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="2.2" strokeLinecap="round" />

    {/* ══ GLASSES (gold wire-frame, round) ══ */}
    <circle cx="89" cy="116" r="15" fill="rgba(180,210,240,0.1)" stroke="#c8a830" strokeWidth="2" />
    <ellipse cx="83" cy="110" rx="5" ry="3" fill="rgba(255,255,255,0.18)" transform="rotate(-20,83,110)" />
    <circle cx="131" cy="116" r="15" fill="rgba(180,210,240,0.1)" stroke="#c8a830" strokeWidth="2" />
    {/* Bridge */}
    <path d="M 104 116 Q 110 113 116 116" fill="none" stroke="#c8a830" strokeWidth="1.8" />
    {/* Temple arms */}
    <path d="M 74 113 Q 66 111 62 113" fill="none" stroke="#c8a830" strokeWidth="1.5" />
    <path d="M 146 113 Q 154 111 158 113" fill="none" stroke="#c8a830" strokeWidth="1.5" />

    {/* ══ EYES ══ */}
    {/* Left */}
    <ellipse cx="89" cy="116" rx="10" ry="7" fill="white" />
    <circle cx="89" cy="116" r="5.5" fill="#4a3020" />
    <circle cx="89" cy="116" r="3.5" fill="#2a1a10" />
    <circle cx="91" cy="113" r="2" fill="white" />
    <circle cx="88" cy="119" r="1" fill="rgba(255,255,255,0.5)" />
    <path d="M 79 116 Q 89 110 99 115" fill="none" stroke="#1a0c08" strokeWidth="1.8" strokeLinecap="round" />
    {/* Right */}
    <ellipse cx="131" cy="116" rx="10" ry="7" fill="white" />
    <circle cx="131" cy="116" r="5.5" fill="#4a3020" />
    <circle cx="131" cy="116" r="3.5" fill="#2a1a10" />
    <circle cx="133" cy="113" r="2" fill="white" />
    <path d="M 121 115 Q 131 110 141 116" fill="none" stroke="#1a0c08" strokeWidth="1.8" strokeLinecap="round" />

    {/* ══ WATCHMAKER'S LOUPE (brass, right eye) ══ */}
    <circle cx="131" cy="116" r="20" fill="none" stroke="url(#wm_loupe)" strokeWidth="4" />
    <circle cx="131" cy="116" r="17" fill="rgba(180,220,255,0.08)" stroke="rgba(210,180,48,0.28)" strokeWidth="1" />
    <ellipse cx="124" cy="110" rx="7" ry="4.5" fill="rgba(255,255,255,0.22)" transform="rotate(-20,124,110)" />
    {/* Loupe headband over brow */}
    <path d="M 114 104 Q 124 100 131 96 Q 140 92 150 105" fill="none" stroke="#c8a830" strokeWidth="2" strokeLinecap="round" />
    {/* Right-side clip */}
    <path d="M 151 116 Q 156 111 160 115" fill="none" stroke="#c8a830" strokeWidth="2.2" strokeLinecap="round" />

    {/* ══ NOSE ══ */}
    <path d="M 110 128 Q 103 139 102 145 Q 110 152 118 145 Q 117 139 110 128"
      fill="#d4a878" />
    <path d="M 102 145 Q 110 152 118 145" fill="none" stroke="#b09060" strokeWidth="2" strokeLinecap="round" />
    <ellipse cx="107" cy="135" rx="3" ry="4" fill="rgba(255,218,178,0.28)" transform="rotate(-10,107,135)" />

    {/* ══ WHITE MUSTACHE (bushy, distinguished) ══ */}
    <path d="M 93 155 Q 102 148 110 150 Q 118 148 127 155 Q 120 166 110 162 Q 100 166 93 155 Z"
      fill="#dcd4cc" stroke="#b0a898" strokeWidth="1" />
    <path d="M 96 154 Q 110 157 124 154" fill="none" stroke="rgba(255,255,255,0.45)" strokeWidth="2" strokeLinecap="round" />
    <path d="M 97 150 Q 103 147 110 149" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M 123 150 Q 117 147 110 149" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.2" strokeLinecap="round" />

    {/* ══ MOUTH (warm satisfied smile) ══ */}
    <path d="M 100 163 Q 110 173 120 163" fill="none" stroke="#a06848" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M 104 166 Q 110 169 116 166" fill="rgba(210,130,90,0.18)" />
    <circle cx="98" cy="161" r="2" fill="rgba(190,110,70,0.22)" />
    <circle cx="122" cy="161" r="2" fill="rgba(190,110,70,0.22)" />

    {/* ══ CHEEK WARMTH ══ */}
    <ellipse cx="75" cy="129" rx="13" ry="9" fill="rgba(220,110,80,0.15)" />
    <ellipse cx="145" cy="129" rx="13" ry="9" fill="rgba(220,110,80,0.15)" />
  </svg>
);

export default WatchmakerCharacter;
